import { userAuthMobileLoginApi } from "../../api/user/userAuthMobileLoginApi"

type PayloadShape = Parameters<typeof userAuthMobileLoginApi>[0]

export async function userAuthMobileLoginService(payload: PayloadShape) {
	payload.mobile.mobileNo = payload.mobile.mobileNo.toString()
	const { token } = await userAuthMobileLoginApi(payload)
	return { token }
}
